import api from '@/api/article/label'

export const title = {
  Add: '添加标签',
  Edit: '编辑标签'
}

export const strategyCommand = {
  edit(data) {
    this.title = title.Edit
    this.visible = true
    this.isEdit = true
    this.$nextTick(() => {
      this.form = { ...data }
    })
  },
  status(data) {
    const _this = this
    const { status } = data
    this.$confirm({
      content: `确定要${status === 1 ? '禁用' : '启用'}吗？`,
      async onOk() {
        const res = await api.updateStatusLabel({ id: data.id, status: status === 1 ? 2 : 1 })
        if (_this.$validate(res)) {
          _this.$message.success('操作成功~')
          _this.getList()
        }
      }
    })
  },
  async delete(data) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      async onOk() {
        const res = await api.deleteLabel({ id: data.id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}
